export function toIsNumberFormat(num) {
  return num.toLocaleString()
    .replace(/,/g, "TEMP")
    .replace(/\./g, ",")
    .replace(/TEMP/g, ".");;
}
